/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_File_Mac_Dmg_TitleInputs */

const en_pc_dl_file_mac_dmg_title = /** @type {(inputs: Pc_Dl_File_Mac_Dmg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disk image (Universal)`)
};

const zh_pc_dl_file_mac_dmg_title = /** @type {(inputs: Pc_Dl_File_Mac_Dmg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`磁盘映像（通用版）`)
};

/**
* | output |
* | --- |
* | "Disk image (Universal)" |
*
* @param {Pc_Dl_File_Mac_Dmg_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_file_mac_dmg_title = /** @type {((inputs?: Pc_Dl_File_Mac_Dmg_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_File_Mac_Dmg_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_file_mac_dmg_title(inputs)
	return zh_pc_dl_file_mac_dmg_title(inputs)
});
export { pc_dl_file_mac_dmg_title as "pc.dl.file.mac_dmg.title" }